<ng-container *ngIf="msg">

  <!-- SYSTEM EVENT — flat right-aligned single line -->
  <div *ngIf="msg.isSystem" class="sys-line">
    <span class="sys-ch">{{ channelIcon(msg.channel) }} {{ msg.channel }}</span>
    <span class="sys-body">{{ msg.body }}</span>
    <span class="sys-meta">{{ msg.createDate }}</span>
  </div>

  <!-- INTERNAL NOTE — flat right-aligned single line with yellow tint -->
  <div *ngIf="msg.isNote" class="sys-line note">
    <span class="sys-ch">📝 Note</span>
    <span class="sys-body">{{ msg.body }}</span>
    <span class="sys-meta">{{ msg.sentBy }} · {{ msg.createDate }}</span>
  </div>

  <!-- INCOMING BUBBLE (guest, left) -->
  <div *ngIf="!msg.isSystem && !msg.isNote && msg.isIncoming" class="bubble in">
    <div class="tools">
      <button title="Reply">↩</button>
      <button title="Add Task">✓</button>
      <button title="Archive">🗄</button>
      <button title="Label">🏷</button>
    </div>
    <div class="body">
      <!-- Collapsed: always plain text preview; fallback when content is stored externally (S3) -->
      <div *ngIf="!expanded" class="preview">
        <ng-container *ngIf="previewText; else noBodyIn">{{ previewText }}</ng-container>
        <ng-template #noBodyIn><span class="no-body-placeholder">— message content unavailable —</span></ng-template>
      </div>
      <!-- Expanded: render HTML if present, otherwise plain text -->
      <div *ngIf="expanded && hasHtml" class="email-html" [innerHTML]="safeHtml"></div>
      <div *ngIf="expanded && !hasHtml" class="preview open">{{ msg.body }}</div>
      <button *ngIf="isLongBody || hasHtml" class="expand" (click)="toggleExpand()">
        {{ expanded ? 'View less ▴' : 'View more ▾' }}
      </button>
      <div class="attachments" *ngIf="msg.attachmentCount > 0">
        <ng-container *ngIf="!attachmentsLoaded">
          <span class="att-badge" (click)="loadAttachments()">
            📎 {{ msg.attachmentCount }} attachment{{ msg.attachmentCount > 1 ? 's' : '' }}
          </span>
          <span *ngIf="attachmentsLoading" class="att-loading"> Loading…</span>
        </ng-container>
        <ng-container *ngIf="attachmentsLoaded">
          <ng-container *ngFor="let att of attachments">
            <a *ngIf="att.available" class="att-pill"
               [href]="att.url" target="_blank" rel="noopener noreferrer">
              📎 {{ att.fileName }}
            </a>
            <span *ngIf="!att.available" class="att-pill att-pill--unavailable" title="Attachment not yet available">
              📎 {{ att.fileName }}
            </span>
          </ng-container>
          <span *ngIf="attachments.length === 0" class="att-badge muted">No attachments found</span>
        </ng-container>
      </div>
      <span class="foot">
        <span class="ch">{{ channelIcon(msg.channel) }} {{ msg.channel }}</span>
        <span class="who">{{ msg.senderName }}</span>
        <span class="t">{{ msg.createDate }}</span>
      </span>
    </div>
  </div>

  <!-- OUTGOING BUBBLE (KBM, right) -->
  <div *ngIf="!msg.isSystem && !msg.isNote && !msg.isIncoming" class="bubble out">
    <div class="tools">
      <button title="Reply">↩</button>
      <button title="Forward">↪</button>
      <button title="Add Task">✓</button>
      <button title="Archive">🗄</button>
      <button title="Label">🏷</button>
    </div>
    <div class="body">
      <!-- Collapsed: plain text preview; fallback when content is stored externally (S3) -->
      <div *ngIf="!expanded" class="preview">
        <ng-container *ngIf="previewText; else noBody">{{ previewText }}</ng-container>
        <ng-template #noBody><span class="no-body-placeholder">— sent email —</span></ng-template>
      </div>
      <!-- Expanded: render HTML if present -->
      <div *ngIf="expanded && hasHtml" class="email-html" [innerHTML]="safeHtml"></div>
      <div *ngIf="expanded && !hasHtml" class="preview open">{{ msg.body }}</div>
      <button *ngIf="isLongBody || hasHtml" class="expand" (click)="toggleExpand()">
        {{ expanded ? 'View less ▴' : 'View more ▾' }}
      </button>
      <div class="attachments" *ngIf="msg.attachmentCount > 0">
        <ng-container *ngIf="!attachmentsLoaded">
          <span class="att-badge" (click)="loadAttachments()">
            📎 {{ msg.attachmentCount }} attachment{{ msg.attachmentCount > 1 ? 's' : '' }}
          </span>
          <span *ngIf="attachmentsLoading" class="att-loading"> Loading…</span>
        </ng-container>
        <ng-container *ngIf="attachmentsLoaded">
          <ng-container *ngFor="let att of attachments">
            <a *ngIf="att.available" class="att-pill"
               [href]="att.url" target="_blank" rel="noopener noreferrer">
              📎 {{ att.fileName }}
            </a>
            <span *ngIf="!att.available" class="att-pill att-pill--unavailable" title="Attachment not yet available">
              📎 {{ att.fileName }}
            </span>
          </ng-container>
          <span *ngIf="attachments.length === 0" class="att-badge muted">No attachments found</span>
        </ng-container>
      </div>
      <span class="foot">
        <span class="ch">{{ channelIcon(msg.channel) }} {{ msg.channel }}</span>
        <span class="who">{{ msg.senderName }}</span>
        <span class="t">{{ msg.createDate }}</span>
        <span *ngIf="msg.deliveryStatus" class="delivered">✓✓ {{ msg.deliveryStatus }}</span>
      </span>
    </div>
  </div>

</ng-container>
